import BottomSheetWebViewWrapper from '@di-shared/features/common/BottomSheetWebViewWrapper';
import {ChargedDay, GetEvChargeSummaryResponse} from '@di-shared/api/di/__generated';
import useCldrDatetimeFormatter from '@di-shared/utils/useCldrDatetimeFormatter';
import {parseDateWithFormat} from '@shared/dateUtils';
import EvBatteryChargingHabitBottomSheet, {
  DEFAULT_CAUTION_LEVEL,
} from '@di-shared/features/home/kr/ev-battery/monitor/EvBatteryChargingHabitBottomSheet';

const BOTTOM_SHEET_FALLBACK_HEIGHT = 300;

function EvBatteryChargingHabitBottomSheetPage() {
  const chargedDays = window.data.chargedDays as unknown as ChargedDay[];
  const {avgMinSoc, avgMaxSoc} = window.data.summaryData as unknown as GetEvChargeSummaryResponse;
  const CldrDatetimeFormatter = useCldrDatetimeFormatter();

  const showCautionZone = chargedDays.some(({minSoc}) => minSoc < DEFAULT_CAUTION_LEVEL);
  const graphItems = chargedDays.map(({minSoc, maxSoc, chargedDate}) => {
    const parsedDate = parseDateWithFormat(chargedDate);
    return {
      start: minSoc,
      end: maxSoc,
      title: parsedDate ? CldrDatetimeFormatter.format(parsedDate, 'Md') : '',
      tooltipText: `${parsedDate ? CldrDatetimeFormatter.format(parsedDate, 'yMMMd') : ''}\n${minSoc}% → ${maxSoc}%`,
    };
  });
  return (
    <BottomSheetWebViewWrapper bottomSheetFallbackHeight={BOTTOM_SHEET_FALLBACK_HEIGHT}>
      <EvBatteryChargingHabitBottomSheet
        onExit={() => window.bottomSheetClose(null)}
        graphItems={graphItems}
        showCautionZone={showCautionZone}
        avgMinSoc={avgMinSoc}
        avgMaxSoc={avgMaxSoc}
      />
    </BottomSheetWebViewWrapper>
  );
}

export default EvBatteryChargingHabitBottomSheetPage;
